// extracted by mini-css-extract-plugin
module.exports = {"icon-and-title-container":"styles_icon-and-title-container__2JL4X","icon":"styles_icon__33nj3"};